import PaginationNav from '@/components/pagination-nav';
import MenuListing from '@/features/menu/menu-listing';
import VisitorLayout from '@/layouts/visitor-layout';
import { menu } from '@/routes';
import { Pagination } from '@/types';
import { Head, usePage } from '@inertiajs/react';

export default function Welcome({
    response,
}: {
    response: {
        menuItems: App.Data.MenuItemData[];
        categories: App.Data.CategoryData[];
        types: App.Data.MenuItemTypeData[];
        pagination: Pagination;
        newsletters: App.Data.NewsletterData[];
    };
}) {
    const { filters } = usePage().props;

    return (
        <div className="light min-h-svh">
            <Head>
                <title>Menu</title>
                <meta name="description" content="View our menu and find your favorite coffee and food" />
                <meta name="image" content={import.meta.env.VITE_APP_URL + '/logo.jpg'} />
                <meta name="url" content={menu().url} />
                <meta name="canonical_url" content={menu().url} />
                <meta name="type" content="website" />
                <meta name="author" content="Let\'s Cafe" />
                <meta name="robots" content="index, follow" />
                <meta name="published_time" content={new Date().toISOString()} />
                <meta name="modified_time" content={new Date().toISOString()} />
                <meta name="site_name" content="Let\'s Cafe" />
                <meta name="section" content="Food and Drink" />
                <meta name="tags" content="coffee, tea, cafe" />
                <meta name="twitter_username" content="Let\'s Cafe" />
            </Head>
            <VisitorLayout>
                <MenuListing
                    menuItems={response.menuItems}
                    categories={response.categories}
                    types={response.types}
                />
                <PaginationNav
                    pagination={response.pagination}
                    baseUrl="/menu"
                    query={
                        filters as Record<
                            string,
                            string | number | boolean | null | undefined
                        >
                    }
                />
            </VisitorLayout>
        </div>
    );
}
